export default "__VITE_ASSET__CAspOSwn__"